export default "__VITE_PUBLIC_ASSET__f5ecd74f__"